import { css } from '@emotion/css';

export const googleLoginButtonStyles = css`
  width: 100%;
  height: 40px;
  border: 1px solid #dadce0 !important;
  border-radius: 8px;
  background-color: #ffffff !important;
  color: #3c4043 !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 16px;
  line-height: 1;

  box-shadow: none !important;

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    line-height: 1;
  }

  &:hover {
    background-color: #f8f9fa !important;
    border-color: #dadce0 !important;
    color: #3c4043 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  }

  &:focus {
    background-color: #f8f9fa !important;
    border-color: #dadce0 !important;
    color: #3c4043 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  }

  &:active {
    background-color: #f1f3f4 !important;
    color: #3c4043 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;
  }

  &:disabled {
    background-color: #f8f9fa !important;
    color: #9aa0a6 !important;
    cursor: not-allowed;
    border-color: #f8f9fa !important;
  }
`;

export const googleLogoStyles = css`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: block;
  vertical-align: middle;
`;
